// extracted by mini-css-extract-plugin
export default {"iframe":"LoginDialog-iframe"};